import { Box } from "@mui/material";
import LoadingIndicator from "../../../../components/LoadingIndicator/LoadingIndicator";

const LoadingOverlay = () => (
  <Box
    sx={{
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <LoadingIndicator />
    </Box>
  </Box>
);

export default LoadingOverlay;
